import styled from 'styled-components';
import { Layout, Menu, Button, Typography } from 'antd';
import { ReactComponent as LasuLogo } from '../../assets/icons/LasuLogo.svg';

const { Sider } = Layout;
const { Text } = Typography;
const { Item } = Menu;

export const StyledSider = styled(Sider)`
    overflow: auto;
    right: 0;
    direction: rtl;
    height: 100vh;
    background-color: #F6F8F9;
    transition: all 0.3s ease;
    
`;

export const LogoText = styled(Text)`
    font-size: 18px;
    color: #313131;
    display: flex;
    align-items: center;
`;

export const StyledLasuLogo = styled(LasuLogo)`
    width: 23px;
    height: 24px;
    margin: 5px;
`;

export const StyledSettingsButton = styled(Button).attrs({
    type: 'text'
})`
    border: none;
    background: none;
    outline: none;
    box-shadow: none;
    transition: all 0.3s ease;
    position: absolute;
    bottom: 2.5rem;
    right: 1rem;
`;

export const LogoWrapper = styled.div`
    transition: opacity 0.3s ease, max-height 0.3s ease, width 0.3s ease, padding 0.3s ease;
    display: flex;
    align-items: center;
    overflow: hidden;  // To ensure smooth collapse
`;

export const CollapseButton = styled(Button)`
    border: none;
    background: none; 
    outline: none;
    box-shadow: none;
    transition: all 0.3s ease;
`;

export const StyledMenu = styled(Menu)`
    background-color: #F6F8F9;
    text-align: center; 
    transition: opacity 0.3s ease, max-height 0.3s ease, width 0.3s ease, padding 0.3s ease;
    padding: 0 0.625rem;
    display: flex;
    flex-direction: column;
    height: 87%;
`;

export const StyledMenuItem = styled(Item)<{ $isSelected: boolean }>`
    max-height: 32px;
    height: 32px;
    font-size: 16px;
    color: #313131; 
    padding-right: 0.8rem !important;
    padding-top: 1px;
    padding-bottom: 1px;
    transition: opacity 0.3s ease, max-height 0.3s ease, width 0.3s ease;

    background-color: ${({ $isSelected }) => ($isSelected ? 'rgba(148, 165, 242, 0.2)' : 'initial')};

    &.ant-menu-item-selected {
        color: black;
    }
    a {
        display: flex;        
    }

    svg path {
        fill: ${({ $isSelected }) => ($isSelected ? '#5F5DF0' : 'B0BABF')};
    }

`;

export const StyledLastMenuItem = styled(StyledMenuItem)`
    &.ant-menu-item {
        margin-top: auto;
    }
`;

export const SidebarHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    transition: all 0.3s ease;
    overflow: hidden; /* Ensures elements are hidden when collapsed */

    &.collapsed {
        justify-content: center;
    }
`;

